import CurrencySelect from '@components/CurrencySelect'
import React from 'react'
import {
    ButtonComponent,
    ButtonGroupComponent,
    FormInputComponent,
} from '../../Itinerary/AddEventModal/FormComponents'

interface TripFormProps {
	name: string
	currencyCode: string
	onNameChange: (name: string) => void
	onCurrencyChange: (currencyCode: string) => void
	onSubmit: (e: React.FormEvent) => void
	onCancel: () => void
	submitButtonText: string
	submitDisabled?: boolean
	leftAction?: React.ReactNode
}

const TripForm: React.FC<TripFormProps> = ({
	name,
	currencyCode,
	onNameChange,
	onCurrencyChange,
	onSubmit,
	onCancel,
	submitButtonText,
	submitDisabled = false,
	leftAction,
}) => {
	const footer = (
		<form onSubmit={onSubmit}>
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
				<div>{leftAction}</div>
				<ButtonGroupComponent>
					<ButtonComponent type="button" variant="secondary" onClick={onCancel}>
						Cancel
					</ButtonComponent>
					<ButtonComponent type="submit" variant="primary" disabled={submitDisabled}>
						{submitButtonText}
					</ButtonComponent>
				</ButtonGroupComponent>
			</div>
		</form>
	)

	return (
		<>
			<FormInputComponent
				label="Trip Name"
				htmlFor="trip-name"
				id="trip-name"
				type="text"
				value={name}
				onChange={e => onNameChange(e.target.value)}
				placeholder="Enter trip name..."
				required
				autoFocus
				maxLength={64}
			/>
			<CurrencySelect
				label="Default Currency"
				htmlFor="trip-currency"
				value={currencyCode}
				onChange={onCurrencyChange}
			/>
			{footer}
		</>
	)
}

export default TripForm

